import { DialogComponent } from '@theme/dialog';

/**
 * Pre-order confirmation dialog. Confirming closes the modal and submits
 * the product form so add-to-cart / checkout continue as usual.
 *
 * @extends {DialogComponent}
 */
class PreorderModalComponent extends DialogComponent {
  /**
   * Closes the dialog, then submits the associated product form.
   */
  async confirmPreorder() {
    const formId = this.dataset.formId;
    const submitId = this.dataset.submitButtonId;

    await this.closeDialog();

    const submitButton = submitId ? document.getElementById(submitId) : null;
    if (submitButton instanceof HTMLButtonElement && !submitButton.disabled) {
      submitButton.click();
      return;
    }

    const form = formId ? document.getElementById(formId) : null;
    form?.requestSubmit();
  }
}

if (!customElements.get('preorder-modal-component')) {
  customElements.define('preorder-modal-component', PreorderModalComponent);
}
